<template>
	<div>
		<v-card-title>
			<h2 class="ml-1">Podsumowanie projektu</h2>
		</v-card-title>
		<v-card-text>
			<project-summary-data-view/>
			<project-summary-users-view/>
			<project-summary-tasks-view/>
			<project-summary-amounts-view/>
			<v-layout align-center justify-center>
				<v-btn :disabled="!showFinalReportButton" color="primary" @click="showReport" class="ma-5">
					Podgląd sprawozdania końcowego
				</v-btn>
			</v-layout>
		</v-card-text>
	</div>
</template>

<script>
	import ProjectSummaryDataView from "./components/ProjectSummaryDataView";
	import ProjectSummaryUsersView from "./components/ProjectSummaryUsersView";
	import ProjectSummaryTasksView from "./components/ProjectSummaryTasksView";
	import ProjectSummaryAmountsView from "./components/ProjectSummaryAmountsView";
	import {FinalReport} from "../../../api/generated/FinalReport";

	export default {
		name: "ProjectSummaryView",

		components: {
			ProjectSummaryAmountsView,
			ProjectSummaryTasksView,
			ProjectSummaryUsersView,
			ProjectSummaryDataView
		},

		data() {
			return {
				finalReportStatus: null
			};
		},

		methods: {
			showReport() {
				this.$router.openInNewTab('/view/project/' + this.$route.params.projectId + '/final-report');
			},
			loadFinalReportStatus() {
				FinalReport.getCurrentState(this, this.$route.params.projectId,
					onSuccess => {
						if (onSuccess !== null) {
							this.finalReportStatus = onSuccess.status;
						}
					}, () => this.$messagesBus.$emit("error", "Nie udało się pobrać danych projektu")
				);
			}
		},

		computed: {
			showFinalReportButton() {
				if (this.roles.isAdministrator() || this.roles.isLocalAdministrator()) {
					return true;
				} else if (this.roles.isDepartmentEmployee() || this.roles.isAgencyEmployee()) {
					return this.finalReportStatus === 'APPROVED';
				}
				return false;
			}
		},

		created() {
			this.loadFinalReportStatus();
		}
	};
</script>

<style scoped>

</style>
